import { render, staticRenderFns } from "./DebugMode.vue?vue&type=template&id=1dc52e4d"
import script from "./DebugMode.vue?vue&type=script&lang=js"
export * from "./DebugMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports